import React, { useContext } from "react";
import CommonImage, { ImageType } from "@/components/CommonImage";
import styles from "./index.module.scss";
import { pagePathUrl } from "@/constants/url";
import HotSvg from "../../../assets/icon/hot-colorful.svg";

import Image from "next/image";

export interface ItemContentData {
  slug: string;
  name: string;
  weight: number | React.ReactNode;
  hot_text: string;
  avatar_image: string;
  display_type: string | null;
}

interface ListCardProps<T> {
  id?: string;
  width?: number;
  defaultStyle?: boolean;
  data: (T & ItemContentData)[];
  title: string | React.ReactNode;
  /* 埋点position字段 */
  position: string;
}

// 圈子推荐卡片组件
function ItemCard<T>({
  title,
  width,
  data = [],
  defaultStyle = true,
  id = "",
  position,
}: ListCardProps<T>) {
  return (
    <div
      id={id}
      className={styles.itemCardContainer}
      style={{ width: width || "100%" }}
    >
      <div className={styles.titleContainer}>
        <div className={styles.title}>{title}</div>
        <div
          className={styles.more}
          onClick={() => {
            if (data) {
              window.open(
                `${pagePathUrl.circleList}`
              );
            }
          }}
        >
          更多&gt;&gt;
        </div>
      </div>
      <ul className={styles.itemContent}>
        {data.slice(0,5).map((item, index) => (
          <li
            key={item.slug}
            className={styles.listItem}
            onClick={() => {
              if (item.slug) {
                item.display_type === "THEME"
                  ? window.open(`${pagePathUrl.device}/${item.slug}`)
                  : window.open(
                      `${pagePathUrl.devicesSeries}?series=${item.slug}`
                    );
              }
            }}
          >
            <div className={styles.avatar}>
              <CommonImage
                alt={item.name}
                layout="fill"
                cutMode="fill"
                type={ImageType.avatar}
                src={item.avatar_image}
              />
            </div>
            <div className={styles.link}>
              <div className={styles.text}>{item.name}</div>
              {item.hot_text && (
                <div className={styles.hot}>
                  <HotSvg />
                  <div className={styles.hotText}>{item.hot_text}</div>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ItemCard;
